const LINKS = [
  { label: "About", href: "#about" },
  { label: "Communities", href: "#communities" },
  { label: "Executive Team", href: "#team" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#141A17] text-white py-16 md:py-20"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
          <div className="md:col-span-6">
            <div className="font-heading text-3xl md:text-4xl leading-tight max-w-md">
              The Intersection of{" "}
              <span className="italic text-[#E8B4A0]">Private Equity</span> &amp;
              Community.
            </div>
          </div>
          <div className="md:col-span-3 md:col-start-8">
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => go(l.href)}
                    data-testid={`footer-nav-${l.href.slice(1)}`}
                    className="text-white/70 hover:text-[#E8B4A0] transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-2">
            <div className="text-[10px] uppercase tracking-[0.25em] text-white/40 mb-5">
              Reach us
            </div>
            <p className="text-white/70 leading-relaxed text-sm">
              info@federationco.com
              <br />
              North Carolina &amp; South Carolina
            </p>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <span>
            © {new Date().getFullYear()} The Federation Companies. All rights
            reserved.
          </span>
          <span className="uppercase tracking-[0.2em]">
            HUD-Assisted · Section 8 · PRAC · LIHTC
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
